import router from '@/router';
import Router from 'vue-router';
import Vue from 'vue';
import defaultUrl from '@/api/api.js';
import {store} from '@/vuex/store.js';
import bus from '@/common/eventBus.js';
Vue.use(Router);
const vue = new Vue({
    router,
    store
});
const baseUrl = defaultUrl;
let commonMethods = {
    /**
     * @function toPage() 方法名 页面跳转
     * @param { Array } args 表示参数数组, 可为空.
     * @param { string } args[0] 必传, 页面名称
     * @param { string } args[1] 必传, 导航菜单选中项
     * @param { object } args[2] 选传, 页面跳转所需参数, {
     *     data: { key: '', value: {} }, 页面跳转所需参数
     *     isBlank: true/false,(true表示新开页面跳转,否则表示在当前页跳转)
     * }
     */
    toPage(...args) {
        console.log('This is a way to jump to the page.');
        let len = args.length;
        if(len <= 0) {
            console.log('No parameters, please pass the value.');
            return false;
        } else {
            // 页面名称，导航选中项
            let pageName = null, navName = null;
            pageName = String(args[0]);
            navName = String(args[1]);
            // 设置导航选中项，保存到sessionStorage
            let navStatusObj = { navStatus: args[1] };
            this.setSessionData('navStatus', navStatusObj);
            if(len > 2) {
                // 有参数
                this.setSessionData(args[2].data.key, args[2].data.value);
                this.setSessionData(args[2].data.navKey, args[2].data.pageNavList);
                if(args[2].isBlank) {
                    let query = args[2].data.query ? args[2].data.query : {};
                    // 将数据保存到本地
                    let routeData = vue.$router.resolve({ name: pageName, query: query });
                    // 新开标签页显示
                    window.open(routeData.href, "_blank");
                } else {
                    vue.$router.push({ name: pageName, query: args[2].data.query });
                }
            } else {
                // 直接跳转页面
                vue.$router.push({name: pageName});
            }
        }
    },
    /**
     * @function setVuexData() 方法名 
     * @param { object } obj 必传, 需要保存的数据
     */
    setVuexData(obj) {
        store.commit('setPageData', obj);
    },
    /**
     * @function setSessionData() 方法名 sessionStorage本地存储
     * @param { string } key 必传, 键名, 通过key名获取保存的数据
     * @param { object } value 必传, 键值, 即存/取的数据
     */
    setSessionData(key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    },
    /**
     * @function getSessionData() 方法名 获取sessionStorage数据
     * @param { string } key 必传, 键名, 通过key名获取保存的数据
     */
    getSessionData(key) {
        return JSON.parse(window.sessionStorage.getItem(key));
    },
    /**
     * @function jointPicUrl() 方法名 拼接图片路径方法
     * @param { string } url 必传, 图片路径
     */
    jointPicUrl(url) {
        if(url && typeof url === 'string') {
            let isHTTP = url.slice(0, 4);
            if(isHTTP !== 'http') {
                return baseUrl + url;
            } else {
                return url;
            }
        } else {
            return url;
        }
    },
    /**
     * @function jointWebUrl() 方法名 补全网址
     * @param { string } url 必传 网址
     */
    jointWebUrl(url) {
        if(url && typeof url === 'string') {
            let isHTTP = url.slice(0, 4);
            if(isHTTP !== 'http') {
                return 'http://' + url;
            } else {
                return url;
            }
        } else {
            return url;
        }
    },
    /**
     * @function getNavStatus() 方法名 获取导航菜单选中项
     */
    getNavStatus() {
        if(window.sessionStorage.getItem("navStatus")) {
            let navStatus = JSON.parse(window.sessionStorage.getItem("navStatus")).navStatus;
            bus.$emit('navStatus', navStatus);
        } else {
            bus.$emit('navStatus', 0); // 默认选中首页
        }
    },
    /**
     * @function quickSort() 方法名 快速排序
     * @param { Array } arr 必传 需要排序的数组
     */
    quickSort(arr) {
        // 递归停止条件
        if(arr.length <= 1) {
            return arr;
        }
        // 选取基准值
        let flag = arr.shift();
        // 创建一个左顶堆和一个右顶堆
        let left = [], right = [];
        for(let i = 0; i < arr.length; i++) {
            if(flag > arr[i]) {
                right.push(arr[i]); // 小的放右边， 大的放左边（倒叙）
            } else {
                left.push(arr[i]);
            }
        }
        return [...this.quickSort(left), flag, ...this.quickSort(right)];
    }
}
export default commonMethods;


// WEBPACK FOOTER //
// ./src/common/commonMethods.js